import { Vue, Options } from 'vue-class-component';
import NumberButtons from '@/views/components/NumberButtons/NumberButtons.vue';
import { noAppartmentOptions } from '@/core/utils/EntrancePlant/entrance-plant.utils';
import { EntrancePlantDetailDTO, EntrancePlantStructureCreateDTO, PePlantConfig, PePlantConfigDTO, PlantConfigStep } from '@/../client-generator/generated-clients/plants';
import HelpPopupButton from '@/views/components/HelpPopupButton/HelpPopupButton.vue';
import { HelpType } from '@/views/components/HelpPopupButton/HelpPopupButton';
import plantsClient from '@/core/services/plants';

@Options({
  name: 'DialogEntrancePlantCreateRiserOrNot',
  props: {
    plant: {
      required: true,
      type: Object as () => EntrancePlantDetailDTO,
    },
    structureCreate: {
      required: true,
      type: Object as () => EntrancePlantStructureCreateDTO,
    },
    plantId: {
      type: Number,
      required: false,
    },   
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  components: { NumberButtons, HelpPopupButton },
  emits: ['is-loading', 'onBack', 'onNext', 'plant-edited'],
})
export default class DialogEntrancePlantCreateRiserOrNot extends Vue {
  plant!: EntrancePlantDetailDTO;
  plantId!: number;
  structureCreate!: EntrancePlantStructureCreateDTO;
  pePlantConfig: PePlantConfigDTO = this.structureCreate.pePlantConfig ?? new PePlantConfigDTO();
  hasRiserInterface: boolean = false;
  hasSwitchboardOnBackbone: boolean = false;
  hasApartmentsOnBackbone: boolean = false;
  hasGatesOnBackbone: boolean = false;

  HelpType = HelpType

  gateNumber: number = 1;
  riserNumber: number = 1;
  switchboardNumber: number = 1;
  apartmentNumber: number = 1;
  
  
  async mounted() {
    this.initializeData();
  }

  initializeData() {
    this.hasRiserInterface = (this.pePlantConfig?.numberOfRisers ?? 0) > 0;
    this.hasSwitchboardOnBackbone = (this.pePlantConfig.numbersOfBackboneSwitchboards ?? 0) > 0;
    this.hasApartmentsOnBackbone = (this.pePlantConfig.numbersOfBackboneApartments ?? 0) > 0;
    this.hasGatesOnBackbone = (this.pePlantConfig.numbersOfBackboneGates ?? 0) > 0;
    this.riserNumber = this.pePlantConfig!.numberOfRisers! > 0 ? this.pePlantConfig!.numberOfRisers! : 1;
    this.switchboardNumber = this.pePlantConfig!.numbersOfBackboneSwitchboards! > 0 ? this.pePlantConfig!.numbersOfBackboneSwitchboards! : 1;
    this.apartmentNumber = this.pePlantConfig!.numbersOfBackboneApartments! > 0 ? this.pePlantConfig!.numbersOfBackboneApartments! : 1;
    this.gateNumber = this.pePlantConfig!.numbersOfBackboneGates! > 0 ? this.pePlantConfig!.numbersOfBackboneGates! : 1;
  }
  
  noAppartmentOptions() {
    return noAppartmentOptions(100);
  } 

  handleBackButton() {
    this.$emit('onBack', 'DialogEntrancePlantCreateStep2');
  }

  async handleNextButton() {
    await this.updatePlantStructure(this.getDataToSave());
    this.structureCreate.previousWizardPage = 'DialogEntrancePlantCreateRiserOrNot';
    if (this.hasRiserInterface) {
      this.structureCreate.riserFlow = true;
      if (this.hasGatesOnBackbone) {
        this.structureCreate.pePlantConfig!.currentStep = PlantConfigStep.BACKBONE_GATES_CONFIG;
        this.$emit('onNext', 'DialogEntrancePlantCreateSetupGate');
      } else {
        this.structureCreate.pePlantConfig!.currentStep = PlantConfigStep.RISERS_CONFIG;
        this.$emit('onNext', 'DialogEntrancePlantCreateSetupRiser');
      }
    } else {
      this.structureCreate.riserFlow = false;
      this.$emit('onNext', 'DialogEntrancePlantCreateStep3');
    }
  }

  getDataToSave() {
    this.pePlantConfig.numberOfRisers = this.hasRiserInterface ? this.riserNumber : 0;
    this.pePlantConfig.numbersOfBackboneApartments = this.hasApartmentsOnBackbone ? this.apartmentNumber : 0;
    this.pePlantConfig.numbersOfBackboneGates = this.hasGatesOnBackbone ? this.gateNumber : 0;
    this.pePlantConfig.numbersOfBackboneSwitchboards = this.hasSwitchboardOnBackbone ? this.switchboardNumber : 0;
    this.pePlantConfig.currentStep = PlantConfigStep.RISER_AND_BACKBONE_CONFIG;
    this.structureCreate.pePlantConfig = this.pePlantConfig;
    return new EntrancePlantStructureCreateDTO({
      pePlantConfig: this.pePlantConfig,
      riserFlow: this.hasRiserInterface,
    });
  }

  async updatePlantStructure(structure: EntrancePlantStructureCreateDTO) {
    if (!this.plantId) return;
    this.$emit('is-loading', true);

    try {
      const result = await plantsClient.structure(this.plant.desktopId!, structure);
      this.structureCreate.pePlantConfig = result.pePlantConfig;
      this.structureCreate.pePlantConfig!.pePlantConfig = result.pePlantConfig?.pePlantConfig;
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 6000,
      });
    } finally {
      this.$emit('is-loading', false);
    }
  }

}
